import { render, staticRenderFns } from "./Bg.vue?vue&type=template&id=79881222&scoped=true"
import script from "./Bg.vue?vue&type=script&lang=js"
export * from "./Bg.vue?vue&type=script&lang=js"
import style0 from "./Bg.vue?vue&type=style&index=0&id=79881222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79881222",
  null
  
)

export default component.exports